import type { ReactElement } from 'react'
import Results2LoadResults from '../Results2LoadResults'

export const LastenTable = ({
  loads,
  defaultLoadTab,
  elementId,
}: {
  loads: (AreaLoad | DomainLoad)[] | null
  defaultLoadTab: 'point-load' | 'line-load' | 'area-load'
  elementId?: string
}): ReactElement => (
  <Results2LoadResults loads={loads} defaultLoadTab={defaultLoadTab} elementId={elementId} />
)
